import styled from 'styled-components';

export const StyledBreadcrumb = styled.div`
  display: flex;
  align-items: center;
  padding-block: 24px;

  span {
    font-size: 18px;
    line-height: 28px;
    padding: 4px;
    color: #17324d;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    min-width: 0;

    &[data-onclick='true'] {
      color: ${({ theme }) => theme.colors.title};
      font-weight: 700;
      flex-shrink: 0;
      cursor: pointer;

      &:hover,
      &:focus {
        color: ${({ theme }) => theme.colors.focusSelect};
      }
    }
  }

  svg {
    margin: 4px;
    flex-shrink: 0;
  }
`;
